import { render, staticRenderFns } from "./GenerateApp.vue?vue&type=template&id=204161f6&scoped=true"
import script from "./GenerateApp.vue?vue&type=script&lang=js"
export * from "./GenerateApp.vue?vue&type=script&lang=js"
import style0 from "./GenerateApp.vue?vue&type=style&index=0&id=204161f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204161f6",
  null
  
)

export default component.exports